<div class="list-selection-wrapper">
	<cp-list-selection class="all-data-list"
					   [allData]="unselectedData"
					   [outerSearchMode]="true"
					   [outerSearchTitle]="'AvailableValues.Title'"
					   [showAddAllOnBottom]="true"
					   [navigatable]="false"
					   (addItem)="handleAdd($event);"
					   (removeItem)="handleRemove($event);">
	</cp-list-selection>

	<cp-list-selection class="selected-data-list"
					   [allData]="selectedData"
					   [outerSearchMode]="true"
					   [outerSearchTitle]="'SelectedValues.Title'"
					   [showRemoveAllOnBottom]="true"
					   [alwaysShowRemove]="false"
					   [navigatable]="false"
					   (removeItem)="handleRemove($event);">
	</cp-list-selection>
</div>
